export default __webpack_public_path__ + "static/media/tableNoData.b4273729.svg";